<div class="container content">

    <div class="button-back">
        <app-icons class="icon-back" [type]="'arrow-simple'" [color]="'#000'" [custom]="'left'"></app-icons>
        <span class="text" routerLink="/">Volver</span>
    </div>

    <div class="content-body">
        <div class="title">{{name}}</div>
        <div class="content" [innerHTML]="content | safeHtml"></div>
    </div>


</div>